cv.formatMoney = function(params){
  var showSign = _.has(params, 'show_sign') ? params.show_sign : false;
  var decimalPlaces = _.has(params, 'decimal_places') ? params.decimal_places : 0;
  var currencyCode = _.has(params, 'currency_code') ? params.currency_code : 'USD';

  if(showSign){
    var currencySign = cv.currencySign(currencyCode);
  }else{
    var currencySign = '';
  }

  switch(currencyCode){
    case 'USD':
    case 'AUD':
    case 'CAD':
    case 'GBP':
      return currencySign + accounting.formatMoney(params.amount, "", decimalPlaces, ",", ".");
      break;
    case 'EUR':
    case 'DKK':
      return currencySign + accounting.formatMoney(params.amount, "", decimalPlaces, ".", ",");
      break;
    default:
      return currencySign + accounting.formatMoney(params.amount, "", decimalPlaces, ",", ".");
  }
};
